import { FC } from 'react';

import CustomizationFormCheckbox from '../../../../CustomizationForm/CustomizationFormCheckbox';

import Wrapper from './Wrapper';
import { useWaveFooterCheckbox } from './hooks';

const WaveFooterCheckbox: FC = () => {
  const [
    isCheckboxDisabled,
    isDefaultChecked,
    renderTooltip,
    handleChange
  ] = useWaveFooterCheckbox();

  return (
    <Wrapper>
      <CustomizationFormCheckbox
        id="wave-footer"
        label="Wave.video Footer"
        controlValue={!!isDefaultChecked}
        key={`wave-footer-${isDefaultChecked.toString()}`}
        onChange={handleChange}
        disabled={isCheckboxDisabled}
        {...{ isDefaultChecked, renderTooltip }}
      />
    </Wrapper>
  );
};

export default WaveFooterCheckbox;
